/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"

function NextRecommendedStudySession({
  open_quiz_mode_modal,
  next_recommended_study_session
}) {
  const now = next_recommended_study_session === "now"

  return (
    <div className={`next-recommended-study-session ${now ? "now" : ""}`}>
      {!now && <div className="content">
        {I18n.t("js.embedded_quiz.study_summary.next_recommended")}
        <div className="time">
          <FaIcon name={"fa-hourglass"}/>
          {next_recommended_study_session}
        </div>
      </div>
      }
      {now && <div className="content">
        {I18n.t("js.embedded_quiz.study_summary.next_recommended_now")}
        <div className="time">
          <FaIcon name={"fa-hourglass-now"}/>
          {I18n.t("js.embedded_quiz.study_summary.now")}
        </div>
      </div>
      }
      <button className={`btn btn-small ${now ? "btn-primary" : "btn-link"}`}
              onClick={() => open_quiz_mode_modal("study_mode")}>
        {I18n.t("js.embedded_quiz.study_summary.start_study")}
        <FaIcon name={"fa-arrow-right"}/>
      </button>
    </div>
  )
}

export default NextRecommendedStudySession
